module.exports = __webpack_public_path__ + "static/media/suosikit.d4db4763.jpg";